var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.97705 8.89522C2.76346 8.89522 3.51767 9.20762 4.07375 9.7637C4.62982 10.3198 4.94223 11.074 4.94223 11.8604C4.94223 12.6468 4.62982 13.401 4.07375 13.9571C3.51767 14.5132 2.76346 14.8256 1.97705 14.8256V16.8023C1.97705 17.3266 2.18532 17.8294 2.55604 18.2001C2.92676 18.5709 3.42956 18.7791 3.95383 18.7791H19.7681C20.2924 18.7791 20.7952 18.5709 21.1659 18.2001C21.5366 17.8294 21.7449 17.3266 21.7449 16.8023V14.8256C20.9585 14.8256 20.2043 14.5132 19.6482 13.9571C19.0921 13.401 18.7797 12.6468 18.7797 11.8604C18.7797 11.074 19.0921 10.3198 19.6482 9.7637C20.2043 9.20762 20.9585 8.89522 21.7449 8.89522V6.91843C21.7449 6.39416 21.5366 5.89136 21.1659 5.52064C20.7952 5.14992 20.2924 4.94165 19.7681 4.94165H3.95383C3.42956 4.94165 2.92676 5.14992 2.55604 5.52064C2.18532 5.89136 1.97705 6.39416 1.97705 6.91843V8.89522Z",
    stroke: "#D6B893",
    strokeWidth: 1.97678,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8491 4.94165V6.91843",
    stroke: "#D6B893",
    strokeWidth: 1.97678,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8491 16.8025V18.7793",
    stroke: "#D6B893",
    strokeWidth: 1.97678,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8491 10.8723V12.8491",
    stroke: "#D6B893",
    strokeWidth: 1.97678,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketicon);
export default __webpack_public_path__ + "static/media/ticket icon.6aeaca5c7b808815ad1627b0e96640db.svg";
export { ForwardRef as ReactComponent };